
<div class="regras-page">

  <div class="page-header">
    <div>
      <span class="eyebrow">GERENCIAMENTO</span>
      <h1>Regras de mínimo de noites</h1>
      <p>
        Configure a estadia mínima obrigatória
        por acomodação e data de check-in.
      </p>
    </div>

    <button
      type="button"
      class="btn-primary"
      (click)="novo()"
      *ngIf="!mostrarFormulario">
      + Nova regra
    </button>
  </div>

  <!-- FORMULÁRIO -->

  <section class="panel" *ngIf="mostrarFormulario">

    <div class="panel-header">
      <h2>
        {{ editandoId !== null
        ? 'Editar regra'
        : 'Cadastrar regra' }}
      </h2>
    </div>

    <form [formGroup]="form" (ngSubmit)="salvar()">

      <div class="form-grid">

        <div class="form-field">
          <label for="quartoId">Acomodação *</label>

          <select
            id="quartoId"
            formControlName="quartoId">

            <option
              *ngFor="let quarto of quartos"
              [ngValue]="quarto.id">
              {{ quarto.nome }}
            </option>
          </select>
        </div>

        <div class="form-field">
          <label for="data">Data do check-in *</label>

          <input
            id="data"
            type="date"
            formControlName="data">

          <small *ngIf="
            form.controls.data.touched &&
            form.controls.data.invalid"
                 class="error">
            Informe uma data válida.
          </small>
        </div>

        <div class="form-field">
          <label for="minimoNoites">
            Mínimo de noites *
          </label>

          <input
            id="minimoNoites"
            type="number"
            min="1"
            step="1"
            formControlName="minimoNoites">

          <small *ngIf="
            form.controls.minimoNoites.touched &&
            form.controls.minimoNoites.invalid"
                 class="error">
            Informe pelo menos 1 noite.
          </small>
        </div>

        <div class="form-field status-field">
          <label class="checkbox-label">
            <input
              type="checkbox"
              formControlName="ativo">
            Regra ativa
          </label>
        </div>

      </div>

      <div
        class="preview"
        *ngIf="
          form.controls.data.value &&
          form.controls.minimoNoites.value > 0">

        <strong>Prévia da regra</strong>

        <p>
          Para check-in em
          <b>{{ formatarData(form.controls.data.value) }}</b>,
          serão exigidas no mínimo
          <b>{{ form.controls.minimoNoites.value }} noites</b>.
        </p>

        <p>
          Primeiro check-out permitido:
          <b>
            {{
              calcularCheckout(
                form.controls.data.value,
                form.controls.minimoNoites.value
              )
            }}
          </b>
          ou posteriormente.
        </p>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn-secondary"
          (click)="cancelar()">
          Cancelar
        </button>

        <button
          type="submit"
          class="btn-primary"
          [disabled]="salvando || form.invalid">
          {{ salvando ? 'Salvando...' : 'Salvar regra' }}
        </button>
      </div>

    </form>
  </section>

  <!-- LISTAGEM -->

  <section class="panel">

    <div class="list-header">
      <h2>Regras cadastradas</h2>

      <div class="form-field">
        <select
          aria-label="Filtrar por acomodação"
          [value]="filtroQuarto"
          (change)="filtroQuarto = +$any($event.target).value">

          <option [value]="0">
            Todas as acomodações
          </option>

          <option
            *ngFor="let quarto of quartos"
            [value]="quarto.id">
            {{ quarto.nome }}
          </option>
        </select>
      </div>
    </div>

    <div class="loading" *ngIf="carregando">
      Carregando regras...
    </div>

    <div class="table-wrapper" *ngIf="!carregando">

      <table>
        <thead>
        <tr>
          <th>Acomodação</th>
          <th>Check-in</th>
          <th>Mínimo</th>
          <th>Check-out mínimo</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let regra of regrasFiltradas">

          <td>{{ regra.quartoNome }}</td>

          <td>{{ formatarData(regra.data) }}</td>

          <td>
            {{ regra.minimoNoites }}
            {{ regra.minimoNoites === 1 ? 'noite' : 'noites' }}
          </td>

          <td>
            {{
              calcularCheckout(
                regra.data,
                regra.minimoNoites
              )
            }}
          </td>

          <td>
              <span
                class="status-badge"
                [class.ativo]="regra.ativo"
                [class.inativo]="!regra.ativo">
                {{ regra.ativo ? 'Ativa' : 'Inativa' }}
              </span>
          </td>

          <td>
            <div class="table-actions">

              <button
                type="button"
                class="btn-action"
                (click)="editar(regra)">
                Editar
              </button>

              <button
                type="button"
                class="btn-action"
                (click)="alterarStatus(regra)">
                {{ regra.ativo ? 'Desativar' : 'Ativar' }}
              </button>

              <button
                type="button"
                class="btn-action danger"
                (click)="excluir(regra)">
                Excluir
              </button>

            </div>
          </td>

        </tr>

        <tr *ngIf="regrasFiltradas.length === 0">
          <td colspan="6" class="empty">
            Nenhuma regra cadastrada para este filtro.
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </section>

</div>
